//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-lazy-payment-icon',
  props: {
    icon: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    dynamicIcon() {
      return require(`@/assets/images/icons/${this.mapIconToFilename(this.icon)}`)
    },
    inlineStyle() {
      if (!this.loaded) {
        return {}
      }
      return {
        backgroundImage: `url(${this.dynamicIcon})`,
      }
    },
  },
  methods: {
    mapIconToFilename(icon) {
      switch (icon) {
        case 'afterpay-small':
          return 'afterpay-2020.svg'
        case 'paypal-certified':
          return 'paypal-certified/paypal-certified.jpg'
        case 'klarna-logo-small':
          return 'klarna_logo.svg'
        default:
          return this.icon + '.svg'
      }
    },
    onViewportIntersection(event) {
      if (event.type === 'enter' && !this.loaded) {
        this.loaded = true
      }
    },
  },
}
